import React, { useEffect, useState } from 'react';
import Navigation from './0-common-components/Navigation';
import { Header, ServiceSearchAndFilters, ResultsTable } from './1-bibliotheque-prix';
import { Chiffrage } from './3-chiffrage';
import { Ratio } from './2-ratio';
import { MeilleurFournisseur } from './4-meilleur-fournisseur';
import { SuiviProjets } from './5-suivi-projets';
import ChallengerDevis from './pages/ChallengerDevis';
import PerformanceMarches from './pages/PerformanceMarches';
import { ComparateurMain } from './8-comparateur';
import { AnalyseAO } from './9-analyse-ao';
import { ObservatoireROI } from './10-observatoire-roi';
import { EtudeOpportunite } from './11-etude-opportunite';
import ChatWidget from './0-common-components/ChatWidget';
import { FilterProvider } from './99-contexts/FilterContext';
import { RatioPromotionProvider } from './99-contexts/RatioPromotionContext';

type PageKey =
  | 'observatoireRoi'
  | 'bibliotheque'
  | 'ratio'
  | 'etudeOpportunite'
  | 'chiffrage'
  | 'performanceMarches'
  | 'meilleurFournisseur'
  | 'suiviProjets'
  | 'challengerDevis'
  | 'comparateur'
  | 'analyse-ao'
  | 'CTA'; // accessible via ?page=CTA, redirige vers le déploiement séparé de l'extracteur CTA

const VALID_PAGES: ReadonlySet<PageKey> = new Set<PageKey>([
  'observatoireRoi', 'bibliotheque', 'ratio', 'etudeOpportunite', 'chiffrage',
  'performanceMarches', 'meilleurFournisseur', 'suiviProjets',
  'challengerDevis', 'comparateur', 'analyse-ao', 'CTA',
]);

// À remplacer par l'URL réelle une fois l'extracteur CTA déployé sur Vercel.
const EXTRACT_CTA_URL = process.env.REACT_APP_EXTRACT_CTA_URL || 'https://extract-cta.vercel.app';

function getInitialPage(): PageKey {
  if (typeof window === 'undefined') return 'observatoireRoi';
  const param = new URLSearchParams(window.location.search).get('page');
  return param && VALID_PAGES.has(param as PageKey) ? (param as PageKey) : 'observatoireRoi';
}

function App() {
  const [currentPage, setCurrentPage] = useState<PageKey>(getInitialPage);

  useEffect(() => {
    if (currentPage === 'CTA') window.location.replace(EXTRACT_CTA_URL);
  }, [currentPage]);

  if (currentPage === 'CTA') return null;

  return (
    <FilterProvider>
      <RatioPromotionProvider>
        <div className="min-h-screen bg-gray-50">
          <Navigation currentPage={currentPage} onPageChange={setCurrentPage} />

          {currentPage === 'observatoireRoi' ? (
            <ObservatoireROI />
          ) : currentPage === 'bibliotheque' ? (
            <div className="max-w-7xl mx-auto px-4 py-8">
              <Header />
              <ServiceSearchAndFilters />
              <ResultsTable />
            </div>
          ) : currentPage === 'ratio' ? (
            <Ratio onNavigateToChiffrage={() => setCurrentPage('chiffrage')} />
          ) : currentPage === 'etudeOpportunite' ? (
            <EtudeOpportunite />
          ) : currentPage === 'chiffrage' ? (
            <Chiffrage />
          ) : currentPage === 'performanceMarches' ? (
            <PerformanceMarches />
          ) : currentPage === 'meilleurFournisseur' ? (
            <MeilleurFournisseur />
          ) : currentPage === 'suiviProjets' ? (
            <SuiviProjets />
          ) : currentPage === 'comparateur' ? (
            <ComparateurMain />
          ) : currentPage === 'analyse-ao' ? (
            <AnalyseAO />
          ) : (
            <ChallengerDevis />
          )}

          <ChatWidget />
        </div>
      </RatioPromotionProvider>
    </FilterProvider>
  );
}

export default App; 